/**
 * device.js
 * Written by: Alex Kasemir
 */

/**
 * Description of the device reducer
 */
const device = (state = {}, action) => {
  switch (action.type) {
    case `SET_DEVICE_TYPE`:
      return action.config;
    default:
      return state;
  }
};

export default device;
